module.exports = __webpack_public_path__ + "static/media/home-icon.cba8c382.svg";